import { useField } from "formik";
import { useContext } from "react";
import { RfxContext } from "newui/features/Rfx/context/RfxContext";

interface UseSmartFieldSelectionOptions {
	shouldSubmit?: boolean;
}

interface UseSmartFieldSelectionReturn {
	error: string | undefined;
	isSubmitting: boolean;
	touched: boolean;
	value: number[];
	isSelected: (listValue: number) => boolean;
	selectHandler: (listValue: number) => Promise<void>;
}

export const useSmartFieldSelection = (
	props: { name: string },
	options: UseSmartFieldSelectionOptions = {}
): UseSmartFieldSelectionReturn => {
	const { shouldSubmit = false } = options;
	const [_field, meta, helper] = useField<number[]>(props);
	const { value, error, touched } = meta;
	const { setValue, setTouched } = helper;
	const { saveHandler } = useContext(RfxContext);

	const isSelected = (listValue: number): boolean =>
		Array.isArray(value) && value.length > 0
			? value.includes(listValue)
			: false;

	const selectHandler = async (listValue: number): Promise<void> => {
		setTouched(true);
		let updated: number[];
		if (isSelected(listValue)) {
			updated = value.filter((val) => val !== listValue);
		} else {
			updated = Array.isArray(value) ? [...value, listValue] : [listValue];
		}
		setValue(updated);
		if (shouldSubmit && saveHandler) {
			setTimeout(async () => {
				await saveHandler();
			}, 0);
		}
	};

	return {
		value,
		error,
		touched,
		isSelected,
		selectHandler,
		isSubmitting: false,
	};
};
